import React, { useState, useContext, useEffect } from 'react';
import Highcharts from 'highcharts'
import axios from 'axios';
import HighchartsReact from 'highcharts-react-official'
import UserContext  from '../../context/Globales/UserContext';

const Grafico2 =()=> {
	


const [stategrafi, setState] = React.useState();



// FUNCION PARA CONVERTIR GRAFICO EN IMAGEN;


const pdfgrafico =()=>{
	///let link = "data:image/svg+xml;base64," + btoa(this.lineChartRef.current.CHART.current.chart.getSVG());

    const chartoptions = JSON.stringify(options)


//Create a data body with the following parameters 
    let data = {
      options: chartoptions,
      filename: 'LineChart',
      async: true
    }

    let url = "https://export.highcharts.com/"
    let returnedimageurl = ""
    //setState will be called within the Axios return so "This" must 
    let self = this

    axios({
     method: 'POST',
     url: 'https://export.highcharts.com/',
     data: data,
    })
    .then(function (response) {
      returnedimageurl= url +response.data;

	  let RutaImg = returnedimageurl.replace('data:image/svg+xml;base64,', '');
	  localStorage.setItem("imgPdfGrafi", JSON.stringify(RutaImg));
		console.log('RutaImg:::::', RutaImg);
      setState({
        activityChartPng: url
      },) //self.allowDownload())

		// console.log(returnedimageurl);
    })
    .catch(function (response) {
        //handle error
     // console.log(response);
    }); 

}
    


	const  {  datoIC }= useContext(UserContext);

	useEffect(() => {
		pdfgrafico(); // inicializo la funcion de  la imagen para el pdf EMpresa o persona
	
	}, []);

			let Data1 = parseInt(datoIC && datoIC.DetallesMorosidadesYProtestos?.DistribucionPeriodosAcumulados?.MasDe24Meses.Montos.split(".").join("")) / 1000;
			let Data2 = parseInt(datoIC && datoIC.DetallesMorosidadesYProtestos?.DistribucionPeriodosAcumulados?.De12a24Meses.Montos.split(".").join("")) / 1000;
			let Data3 = parseInt(datoIC && datoIC.DetallesMorosidadesYProtestos?.DistribucionPeriodosAcumulados?.De6a12Meses.Montos.split(".").join("")) / 1000;
			let Data4 = parseInt(datoIC && datoIC.DetallesMorosidadesYProtestos?.DistribucionPeriodosAcumulados?.Ultimos6Meses.Montos.split(".").join("")) / 1000;
			let contai;
			
			const options = {
				chart: {
					renderTo: contai,
					zoomType: 'xy'
				},
				credits: {
					text: 'pch.cl',
					href: false,
				},
				title: {
					text: ''
				},
				exporting: {
							  enabled: false
							},
				subtitle: {
					text: ''
				},
				xAxis: [{
					categories: [' ','Mas de 24 Meses', '12 a 24 Meses', '6 a 12 Meses', 'Ultimos 6 Meses'],
					crosshair: true
				}],
				yAxis: [{ // Primary yAxis
					labels: {
						format: '{value} Cant.',
						style: {
							color: 'black'
						}
					},
					title: {
						text: 'Cant. Doctos Acumulados',
						style: {
							color: 'black'
						}
					},
					opposite: true

				}, { // Secondary yAxis
					gridLineWidth: 0,
					title: {
						text: 'Montos en Miles Ingresados',
						style: {
							color: Highcharts.getOptions().colors[0]
						}
					},
					labels: {
						format: '{value} M',
						style: {
							color: Highcharts.getOptions().colors[0]
						}
					}

				}],
				tooltip: {
					shared: true
				},
				legend: {
					layout: 'vertical',
					align: 'left',
					x: 80,
					verticalAlign: 'top',
					y: 55,
					floating: true,
					backgrocontainer1undColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'
				},
				series: [{
					name: 'Monto Miles Ingresados',
					type: 'spline',
					yAxis: 1,
					data: [0,parseInt(Data1), parseInt(Data2), parseInt(Data3), parseInt(Data4)],
					tooltip: {
						valueSuffix: ''
					}

				}, {
					name: 'Cant. Doctos Acumulados',
					type: 'spline',
					data: [0,parseInt(datoIC && datoIC.DetallesMorosidadesYProtestos?.DistribucionPeriodosAcumulados?.MasDe24Meses.AcumuladoDocumentos), parseInt(datoIC && datoIC.DetallesMorosidadesYProtestos?.DistribucionPeriodosAcumulados?.De12a24Meses.AcumuladoDocumentos), parseInt(datoIC && datoIC.DetallesMorosidadesYProtestos?.DistribucionPeriodosAcumulados?.De6a12Meses.AcumuladoDocumentos), parseInt(datoIC && datoIC.DetallesMorosidadesYProtestos?.DistribucionPeriodosAcumulados?.Ultimos6Meses.AcumuladoDocumentos)],
					tooltip: {
						valueSuffix: ''
					}
				}]
			};
	const plugins = [
		{
			afterDraw: (chartInstance, easing) => {
				const { ctx } = chartInstance.chart;
				//ctx.fillText('This text drawn by a plugin', 300, 300);
			}
		}
	];


		return (
            <>
			
			<HighchartsReact
        	highcharts={Highcharts}
        	options={options}
      />
	
            </>
		);

}

export default Grafico2;